import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import TwoColumnCard from "../../widgets/twoColumnCard/TwoColumnCard";
import TwoColumnCardImageBottom from "../../widgets/twoColumnCardImageBottom/TwoColumnCardImageBottom";
import FullWidthColumnCard from "../../widgets/fullWidthColumnCard/FullWidthColumnCard";
import FactCard from "../../widgets/factCard/FactCard";
import "./TwoColumnGrid.scss";
import {
  BackgroundKeyToColor
} from "../../../utils/datasources";
import TwoColumnCardMetric from "../../widgets/twoColumnCardMetric/TwoColumnCardMetric";

const TwoColumnGrid = (blok) => {
  const { content } = blok.blok;

  const Components = {
    two_column_card: TwoColumnCard,
    two_column_card_image_bottom: TwoColumnCardImageBottom,
    full_width_column_card: FullWidthColumnCard,
    two_column_card_metric: TwoColumnCardMetric,
    fact_card: FactCard,
  };
  let componentRows = {
    full_width: [],
    two_col: [],
  };
  content.forEach((element) => {
    if (typeof Components[element.component] !== "undefined") {
      const Component = Components[element.component];
      if (element.component === "full_width_column_card") {
        componentRows.full_width.push(
          <Col
            key={element._uid}
            xs={12}
            className="full-card-wrapper"
            style={{
              backgroundColor: BackgroundKeyToColor(element.background_color),
            }}
          >
            <Component blok={element} />
          </Col>
        );
      } else {
        componentRows.two_col.push(
          <Col
            lg={6}
            md={12}
            key={element._uid}
            className="card-wrapper"
            style={{
              backgroundColor:
                element.component !== "two_column_card_image_bottom"
                  ? BackgroundKeyToColor(element.background_color)
                  : element.background_color,
            }}
          >
            <Component blok={element} />
          </Col>
        );
      }
    }
  });
  const keys = Object.keys(componentRows);
  return (
    <PanelWrapper blok={blok.blok}>
      <div className="grid-wrapper shadow-cards">
        <Container className="panel-radius">
          {keys ? keys.map((row,idx) => {
            return (
              <Row className="justify-content-center two-col-grid-row" key={`${row}_${idx}`}>
                {componentRows[row] ? componentRows[row].map((element) => (
                element )) : []}
              </Row>
            )
          }) : []}
        </Container>
      </div>
    </PanelWrapper>
  );
};

export default TwoColumnGrid;
